module.exports = __webpack_public_path__ + "img/nuvem-virus.a5671641.png";